import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const AdminHeader = ({ title, description, user, children }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear authentication state
    localStorage.removeItem('authToken');
    localStorage.removeItem('userRole');
    navigate('/login');
  };

  const handleLogoClick = () => {
    navigate('/home');
  };

  return (
    <header className="bg-card border-b border-border shadow-sm">
      <div className="px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <button 
            onClick={handleLogoClick}
            className="flex items-center space-x-2 hover:opacity-80 transition-opacity"
          >
            <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
              <Icon name="Ticket" size={20} color="white" />
            </div>
            <span className="text-lg font-semibold text-foreground">Tixful</span>
          </button>

          {/* User Profile */}
          <div className="flex items-center space-x-4">
            <div className="hidden sm:flex items-center space-x-2 text-sm text-muted-foreground">
              <Icon name="Clock" size={16} />
              <span>Last updated: {new Date()?.toLocaleTimeString()}</span>
            </div>
            
            {/* User Profile Icon and Info */}
            <div className="flex items-center space-x-3">
              <div className="text-right hidden sm:block">
                <div className="text-sm font-medium text-foreground">{user?.name}</div>
                <div className="text-xs text-muted-foreground">{user?.role}</div>
              </div>
              <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
                <Icon name="User" size={20} color="white" />
              </div>
            </div>

            <Button
              variant="outline"
              size="sm"
              iconName="LogOut"
              onClick={handleLogout}
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>
      {/* Navigation Tabs */}
      <div className="border-t border-border px-6">
        <nav className="flex space-x-1 overflow-x-auto">
          <button
            onClick={() => navigate('/admin-portal-dashboard')}
            className={`flex items-center px-4 py-3 text-sm font-medium whitespace-nowrap transition-colors border-b-2 ${
              window.location?.pathname === '/admin-portal-dashboard' ?'border-primary text-primary bg-primary/5' :'border-transparent text-foreground hover:text-primary hover:border-primary/50'
            }`}
          >
            <Icon name="BarChart3" size={16} className="mr-2" />
            <span className="hidden sm:inline">Overview</span>
            <span className="sm:hidden">Overview</span>
          </button>
          <button
            onClick={() => navigate('/admin/events')}
            className={`flex items-center px-4 py-3 text-sm font-medium whitespace-nowrap transition-colors border-b-2 ${
              window.location?.pathname === '/admin/events' ?'border-primary text-primary bg-primary/5' :'border-transparent text-foreground hover:text-primary hover:border-primary/50'
            }`}
          >
            <Icon name="Calendar" size={16} className="mr-2" />
            <span className="hidden sm:inline">Events</span>
            <span className="sm:hidden">Events</span>
          </button>
          <button
            onClick={() => navigate('/admin/users')}
            className={`flex items-center px-4 py-3 text-sm font-medium whitespace-nowrap transition-colors border-b-2 ${
              window.location?.pathname === '/admin/users' ?'border-primary text-primary bg-primary/5' :'border-transparent text-foreground hover:text-primary hover:border-primary/50'
            }`}
          >
            <Icon name="Users" size={16} className="mr-2" />
            <span className="hidden sm:inline">Users</span>
            <span className="sm:hidden">Users</span>
          </button>
          <button
            onClick={() => navigate('/admin/financial')}
            className={`flex items-center px-4 py-3 text-sm font-medium whitespace-nowrap transition-colors border-b-2 ${
              window.location?.pathname === '/admin/financial' ?'border-primary text-primary bg-primary/5' :'border-transparent text-foreground hover:text-primary hover:border-primary/50'
            }`}
          >
            <Icon name="DollarSign" size={16} className="mr-2" />
            <span className="hidden sm:inline">Financial</span>
            <span className="sm:hidden">Financial</span>
          </button>
          <button
            onClick={() => navigate('/admin/settings')}
            className={`flex items-center px-4 py-3 text-sm font-medium whitespace-nowrap transition-colors border-b-2 ${
              window.location?.pathname === '/admin/settings' ?'border-primary text-primary bg-primary/5' :'border-transparent text-foreground hover:text-primary hover:border-primary/50'
            }`}
          >
            <Icon name="Settings" size={16} className="mr-2" />
            <span className="hidden sm:inline">Settings</span>
            <span className="sm:hidden">Settings</span>
          </button>
        </nav>
      </div>
      {/* Page Header */}
      {title && (
        <div className="border-t border-border px-6 py-4">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-foreground">{title}</h1>
              {description && (
                <p className="text-sm text-muted-foreground">{description}</p>
              )}
            </div>
            {children && (
              <div className="flex items-center gap-3">
                {children}
              </div>
            )}
          </div>
        </div>
      )}
    </header>
  );
};

export default AdminHeader;